var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFieldClear = function SvgFieldClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#AAA",
    rx: 9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M5.372 5.372a.417.417 0 0 1 .59 0L9 8.411l3.039-3.039a.417.417 0 0 1 .589.59L9.589 9l3.039 3.039a.417.417 0 0 1-.59.589L9 9.589l-3.039 3.039a.417.417 0 0 1-.589-.59L8.411 9 5.372 5.961a.417.417 0 0 1 0-.589",
    clipRule: "evenodd"
  })));
};
export default SvgFieldClear;